<template>
  <vx-card>
    <dashboard-member-stats v-if="stats" :members-stats-resource="stats" ></dashboard-member-stats>
    <dashboard-member-list  :class="stats ? 'mt-10':''" :dashboard-resource="dashboardResource"></dashboard-member-list>
  </vx-card>
</template>

<script>
import DashboardMemberStats from '@/views/app/dashboard/member/dashboard-member-stats';
import DashboardMemberList from '@/views/app/dashboard/member/dashboard-member-list';
import {ResourceImpl} from 'hal-client';

export default {
  name: 'dashboard-member-card',
  components: {
    DashboardMemberList,
    DashboardMemberStats
  },
  props: {
    dashboardResource: ResourceImpl
  },
  data () {
    return {
      loading: true,
      stats: null,
      referrals: null,
      key: 0
    };
  },
  mounted () {
    if (this.dashboardResource.$hasLink('members-stat')) {
      this.dashboardResource.$request().$get('members-stat').then(res => {
        this.stats = res;
      });
    }
  }
};
</script>

<style scoped>

</style>
